import { createSelector } from '@reduxjs/toolkit';
import { DayOfWeek, LocalDate } from '../../../utilities/local-date';
import { today } from './today';

export const mondayThisWeek = createSelector(today, (todayString) =>
  LocalDate.fromString(todayString).withPreviousOrSame(DayOfWeek.MONDAY),
);
